import { CoreAcquisitionConstants } from 'app/interfaces/Image';
import { getKVLimits } from 'app/utils/acquisitionConstants';
import _ from 'lodash';

export default function onAcquisitionConstantChange(
  acquisitionConstants: CoreAcquisitionConstants,
  constantName: keyof CoreAcquisitionConstants | 'mAs',
  value: number
): CoreAcquisitionConstants {
  let parameters: CoreAcquisitionConstants;
  // We always adapt the lowest priority constant to met the requirements
  // kV > mA == mAs > s
  // Changing kV will change mA if mA over max mA for that kV
  // Changing mA will change s to keep mAs constant
  // Changing mAs will change s to keep mA constant

  if (constantName === 'kV') {
    const kvLimits = getKVLimits(value);
    const { mA, s } = acquisitionConstants;
    const targetMAS = mA * s;
    if (kvLimits.mA < mA) {
      const newSeconds = _.round(targetMAS / kvLimits.mA, 3);
      return {
        ...acquisitionConstants,
        kV: value,
        mA: kvLimits.mA,
        s: newSeconds,
      };
    }
  }
  if (constantName === 'mAs') {
    const { mA, s } = acquisitionConstants;
    const previousMS = s * 1000;
    let requiredMS = (value / mA) * 1000;
    const roundedMS = Math.round(requiredMS);
    if (roundedMS === previousMS) {
      requiredMS += requiredMS > previousMS ? 1 : -1;
    }
    return { ...acquisitionConstants, s: requiredMS / 1000 };
  }
  if (constantName === 'mA') {
    const { mA, s } = acquisitionConstants;
    const targetMAS = mA * s;
    const newSeconds = targetMAS / value;
    parameters = { ...acquisitionConstants, mA: value, s: newSeconds };
  } else {
    parameters = { ...acquisitionConstants, [constantName]: value };
  }
  return _.omit(parameters, ['mAs']) as CoreAcquisitionConstants;
}
